import { render, staticRenderFns } from "./studyPathWidge.vue?vue&type=template&id=08ab029e"
import script from "./studyPathWidge.vue?vue&type=script&lang=js"
export * from "./studyPathWidge.vue?vue&type=script&lang=js"
import style0 from "./studyPathWidge.vue?vue&type=style&index=0&id=08ab029e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports